import { trigger, transition, style, animate } from '@angular/animations'
export const listAnimation = trigger('fadeInFlash', [
  transition(':enter', [
    style({
      opacity: 0,
      backgroundColor: '#F8B232'
    }),
    animate(
      '360ms cubic-bezier(0.390, 0.575, 0.565, 1.000)',
      style({ opacity: 1 })
    ),
    animate(
      '1800ms cubic-bezier(0.390, 0.575, 0.565, 1.000)',
      style({
        backgroundColor: '#fff'
      })
    )
  ]),
  transition(':leave', [
    animate(
      '360ms cubic-bezier(0.390, 0.575, 0.565, 1.000)',
      style({ opacity: 0 })
    )
  ])
])
